var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "@api/interceptors/api";
const sendOtp = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Auth/send-otp", query);
    return response;
});
const verifyOtp = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Auth/verify-otp", query);
    return response;
});
const resendOtp = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Auth/resend-otp", query);
    return response;
});
const refreshAccessToken = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Auth/refresh-access-token", query);
    return response;
});
const logout = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Auth/logout", {});
    return response;
});
export const authApi = {
    sendOtp,
    verifyOtp,
    resendOtp,
    refreshAccessToken,
    logout,
};
